import { render, staticRenderFns } from "./MultipleExamSelect.vue?vue&type=template&id=3477b9fc&scoped=true"
import script from "./MultipleExamSelect.vue?vue&type=script&lang=js"
export * from "./MultipleExamSelect.vue?vue&type=script&lang=js"
import style0 from "./MultipleExamSelect.vue?vue&type=style&index=0&id=3477b9fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3477b9fc",
  null
  
)

export default component.exports